import { createContext } from 'react';

export interface CardSummaryContextValue {
  summary: string | undefined;
  setSummary: (summary: string) => void;
}

export const CardSummaryContext = createContext<CardSummaryContextValue | null>(null);
